/**
 * Generated by orval v6.23.0 🍺
 * Do not edit manually.
 * APIs for RCI FE
 * This document describes the APIs provided by NeoAP BE for RCI FE, designed to be integrated into NeoAP FE using `iframe`.\
These APIs utilize cookie-based authentication. All API requests must include the cookie `_ap_session`.

 * OpenAPI spec version: 1
 */

export type GetImportExportHistoriesListSortBy =
  (typeof GetImportExportHistoriesListSortBy)[keyof typeof GetImportExportHistoriesListSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetImportExportHistoriesListSortBy = {
  'submitted_at:asc': 'submitted_at:asc',
  'submitted_at:desc': 'submitted_at:desc',
  'completed_at:asc': 'completed_at:asc',
  'completed_at:desc': 'completed_at:desc',
} as const;
